import Iconify from '@/components/media/iconify';
import { paths } from '@/routes/paths';
import Button from '@mui/material/Button';
import { RouterLink } from '@/routes/components';
import { useTranslation } from 'react-i18next';
import { RHFNumberFormatterText } from '@/components/forms/hook-form/rhf-number-field';
import { ShowIf } from '@/utils/ui/showIf';
import { useAuthContext } from '@/auth/hooks';
import { useState } from 'react';
import { OrderTypes, OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import { OrderListEnhanced } from '@/sections/management/accounts/orders/views/order-list-enhanced';
import { useParams } from '@/routes/hooks';

export function BillingOrderListView() {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const params = useParams();
  const {organizationId} = params;

  const userCanCreate = user?.checkPermission(
    OrionModule.ACCOUNT,
    OrionSubmodule.ACCOUNT.BILLING_ORDER,
    OrionAccess.CREATE
  );
  const [total, setTotal] = useState(0);

  const count = RHFNumberFormatterText({ value: total });

  return (
    <OrderListEnhanced
      orderType={OrderTypes.BILLING_ORDER}
      organizationId={organizationId}
      setTotal={setTotal}
      heading={`${t(`List`)} (${count})`}
      links={[
        { name: t('Accounts'), href: paths.management.accounts.root },
        { name: t('Billing Orders'), href: paths.management.accounts.billingOrders.root },
        { name: t('List') },
      ]}
      action={
        <ShowIf condition={userCanCreate}>
          <Button
            component={RouterLink}
            href={paths.management.accounts.billingOrders.new}
            variant="contained"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
          >
            {t('New Billing Order')}
          </Button>
        </ShowIf>
      }
    />
  );
}
